import React from 'react'

const ShortListTask = () => {
  return (
    <div>ShortListTask</div>
  )
}

export default ShortListTask